import { StoryRepository } from "@/features/story/repositories/story.repository"
import { db, StoryEntity } from "@/shared/lib/db"
import { BaseLocalRepository } from "@/shared/services/repository/BaseRepository"

class StoryLocalRepository extends BaseLocalRepository<StoryEntity> implements StoryRepository {
    constructor() {
        super(db.stories, 'stories')
    }

    async getByKeys(keys: string[]): Promise<StoryEntity[]> {
        const x = await this.table.where('[projectId+title]').equals(keys).toArray()
        return x;
    }
    getAll(filter?: ((item: StoryEntity) => boolean) | undefined): Promise<StoryEntity[]> {
            if (filter) {
            return this.table.filter(filter).toArray()
        }
        return this.table.toArray()
    }
    save(item: StoryEntity, sync?: boolean): Promise<void> {
        return super.save(item, sync)
    }
    delete(id: string, sync?: boolean): Promise<void> {
        return super.delete(id, sync)
    }
}

export const storyLocalRepository = new StoryLocalRepository()